<template>
    <div class="refund-rules">
        <div class="refund-title">什么是精选标</div>
        <p>精选标是出借人自行选择借款给某个借款人，借款人采用等额本息按月还款的一种出借服务。</p>
        <div class="refund-title mt20">精选标发布时间</div>
        <p>无固定发布时间，请您以页面显示为准。</p>
        <div class="refund-title mt20">服务费如何收取？</div>
        <p>详情参见《出借信息咨询与服务协议》</p>
        <div class="refund-title mt20">借款年化利率不等同于年收益率？</div>
        <p>借款年利率不等同于收益率（由于借款人采用等额本息法每月还款），若想达到等同于此利率的收益，建议您循环出借。</p>
        <div class="refund-title mt20">支付成功后什么时候开始计算回报</div>
        <p>精选标全部款项成功支付给借款人后次日开始计算回报，借款人按月等额本息还款，出借人每月收到部分本金和利息。</p>
        <small>
            举例：
            <br />出借人5月1日支付成功，账户出借金额锁定，5月4日款项成功支付给借款人，借款人最晚于6月4日还款，您将收到实际回报。
            <br>
        </small>
        <div class="refund-title mt20">回款方式？</div>
        <p>借款人根据还款计划按月支付本金和利息，借款人还款后款项回到您的存管银行账户中，您可以选择继续出借或提现。</p>
    </div>
</template>
<script>
    import sensors from "sa-sdk-javascript";

    export default {
    data( ) {
        return {};
    },
    mounted( ) {
        sensors.track( "TMCommonProblem" );
    }
};
</script>
<style lang="less">
@import "../css/refundRules.less";

.refund-rules {
    small {
        font-size: 13px;
    }
}

.mt20 {
    margin-top: 20px;
}
</style>
